import { JournalFeed } from "../../components/journal/JournalFeed";
import { JOURNAL_RESOURCE_TYPES } from "../../components/journal/journal-resource-types";

interface Props {
  stepId: string;
}

/**
 * Surface A — the Journal tab on the tournament step detail screen. Streams
 * runtime journal entries scoped to the step (rule engine executions, manual
 * overrides, generation/reset events, etc.). The filter bar is shown so
 * operators can narrow by category, severity, actor, or correlation id.
 */
export function TournamentStepJournalTab({ stepId }: Props) {
  return (
    <JournalFeed
      defaultFilters={{
        primaryResourceType: JOURNAL_RESOURCE_TYPES.TOURNAMENT_STEP,
        primaryResourceId: stepId,
      }}
      title="Journal"
    />
  );
}
